import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 16, height = 17, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 16 17' fill='none'>
  <path d='M9.33329 1.83334H3.99996C3.26663 1.83334 2.67329 2.43334 2.67329 3.16668L2.66663 13.8333C2.66663 14.5667 3.25996 15.1667 3.99329 15.1667H12C12.7333 15.1667 13.3333 14.5667 13.3333 13.8333V5.83334L9.33329 1.83334ZM3.99996 13.8333V3.16668H8.66663V6.50001H12V13.8333H3.99996Z' fill={color} />
</svg>
